import { render, staticRenderFns } from "./AnsweredIcon.vue?vue&type=template&id=5ba35513&"
import script from "./AnsweredIcon.vue?vue&type=script&lang=js&"
export * from "./AnsweredIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports